import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs/Observable';
import { AccessTokenService } from '../access-token/access-token.service';
/**
 * Used by the router to check if the user has access to a given route.
 */
var AuthenticatedGuard = /** @class */ (function () {
    function AuthenticatedGuard(authenticationService, tokenService, router) {
        this.authenticationService = authenticationService;
        this.tokenService = tokenService;
        this.router = router;
    }
    AuthenticatedGuard.prototype.canActivate = function (route, state) {
        return this.isAuthorized(route.params.agencyISIL.toUpperCase(), state.url);
    };
    /**
     * Checks if a route can be access by the current user.
     * It checks for:
     *  - A token.
     *  - The route matches the agency that the user is logged in under.
     *
     *  If the user does not have access, he is redirected to the login page for the agency he is trying to access.
     *  A redirect query parameter is set so that the login page can redirect back after the user has logged in.
     *
     * @param agencyISIL The ISIL of the agency that is being accessed.
     * @param redirectTo An URL to redirect to after logging in.
     * @returns {boolean}
     */
    AuthenticatedGuard.prototype.isAuthorized = function (agencyISIL, redirectTo) {
        var _this = this;
        if (!agencyISIL) {
            return Observable.of(false);
        }
        return this.authenticationService.user
            .combineLatest(this.tokenService.decodedToken)
            .map(function (_a) {
            var user = _a[0], token = _a[1];
            return user && token && user.agency.ISIL === agencyISIL;
        })
            .do(function (isAuthorized) {
            if (!isAuthorized) {
                _this.router.navigate(["/agency/" + agencyISIL + "/login"], {
                    queryParams: { redirectTo: redirectTo },
                    replaceUrl: true
                });
            }
        });
    };
    return AuthenticatedGuard;
}());
export { AuthenticatedGuard };



// WEBPACK FOOTER //
// ./src/app/authentication/shared/authenticated.guard.ts.pre-build-optimizer.js